import { useState, useEffect } from 'react';
import { getProductCategories } from '../services/productService';

interface UseProductCategoriesResult {
  categories: string[];
  loading: boolean;
  error: string | null;
}

export const useProductCategories = (): UseProductCategoriesResult => {
  const [categories, setCategories] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        setError(null);
        const fetchedCategories = await getProductCategories();
        setCategories(['All', ...fetchedCategories]);
      } catch (err) {
        console.error('Error fetching categories:', err);
        setError('Failed to load categories');
        setCategories(['All']); // Fallback to just 'All'
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return {
    categories,
    loading,
    error
  };
}; 